import { MouseEvent } from "react";

export const isKeyboardEvent = (event: MouseEvent<HTMLButtonElement> | KeyboardEvent): event is KeyboardEvent => {
	return event instanceof KeyboardEvent;
};
